import { ReactElement, Ref, useEffect, useState } from 'react';
import { DevicesSelector, DevicesSelectorContainer, DevicesSelectorTrigger } from './style';
import { useOutsideClick } from '../../../utils/useOutsideClick';

export interface DevicesSelectorProps {
	opened: boolean;
	$notRelative?: boolean;
	open?: () => void;
	close?: () => void;
	vMenuPadding?: number;
	children: ReactElement;
	popChildren?: ReactElement;
	triggerDataTest?: string;
}

export function DevicesSelectorMenu({
	children,
	popChildren,
	opened,
	$notRelative = false,
	open,
	close,
	vMenuPadding,
	triggerDataTest,
}: DevicesSelectorProps) {
	const [popMenuTriggerHeight, setPopMenuTriggerHeight] = useState(0);
	const popMenuButtonRef = useOutsideClick(() => {
		close?.();
	});

	useEffect(() => {
		setPopMenuTriggerHeight(popMenuButtonRef.current?.clientHeight || 0);
	}, []);

	return (
		<DevicesSelectorContainer ref={popMenuButtonRef as Ref<HTMLDivElement>} $notRelative={$notRelative}>
			<DevicesSelectorTrigger
				{...(triggerDataTest
					? {
						'data-test': triggerDataTest,
					  }
					: {})}
				{...{
					onClick: (e) => {
						e.stopPropagation();
						if (opened) {
							close?.();
						} else {
							open?.();
						}
					},
				}}
			>
				{children}
			</DevicesSelectorTrigger>
			{opened && (
				<DevicesSelector
				    $notRelative={$notRelative}
					height={popMenuTriggerHeight}
					$vPadding={vMenuPadding}
				>
					{popChildren}
				</DevicesSelector>
			)}
		</DevicesSelectorContainer>
	);
}
